// extracted by mini-css-extract-plugin
export default {"button":"ButtonSelf_button__U-Vls"};